/*=========================================================================================
  File Name: moduleVariablesActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    getSymptoms({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/symptoms/detailed", payload).then((response) => {
                commit("SET_SYMPTOMS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addSymptom({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/symptoms", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    saveSymptom({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/symptoms/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteSymptom({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/symptoms/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    getRiskFactors({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/riskfactors/detailed", payload).then((response) => {
                commit("SET_RISK_FACTORS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateRiskFactorRows({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/riskfactors/order", payload).then((response) => {
                // commit('SET_RISK_FACTORS', response.data.data);
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addRiskFactor({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/riskfactors", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    saveRiskFactor({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/riskfactors/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteRiskFactor({dispatch, commit}, payload) {
        console.log("moxvedi aq?");
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/riskfactors/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    getTbiLocalizations({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/tbilocalizations/detailed", payload).then((response) => {
                commit("SET_TBI_LOCALIZATIONS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addTbiLocalizations({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/tbilocalizations", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    saveTbiLocalizations({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/tbilocalizations/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteTbiLocalization({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/tbilocalizations/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },


    getSideEffects({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/sideeffects/detailed", payload).then((response) => {
                commit("SET_SIDE_EFFECTS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addSideEffect({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/sideeffects", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    addLaboratoryMonitoring({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/monitorings", payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    saveSideEffect({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/sideeffects/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    saveLaboratoryMonitoring({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/monitorings/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteSideEffect({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/sideeffects/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteLaboratoryMonitoring({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/monitorings/" + payload.id).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getLaboratoryMonitoring({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/monitorings/detailed", payload).then((response) => {
                commit("SET_LABORATORY_MONITORING", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
